import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
`;

export const Content = styled.div`
  background: white;
  border-radius: 16px;
  padding: 48px 40px;
  max-width: 480px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);

  @media (max-width: 768px) {
    padding: 32px 24px;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 32px;

  img {
    height: 60px;
    width: auto;
  }
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #2d3748;
  text-align: center;
  margin-bottom: 12px;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: #718096;
  text-align: center;
  margin-bottom: 32px;
  line-height: 1.6;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ButtonWrapper = styled.div`
  margin-top: 8px;
`;

export const BackLink = styled.a`
  display: block;
  text-align: center;
  color: #667eea;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  margin-top: 16px;
  transition: color 0.2s;

  &:hover {
    color: #764ba2;
    text-decoration: underline;
  }
`;

export const LoadingMessage = styled.div`
  text-align: center;
  color: #718096;
  padding: 40px 0;
  font-size: 16px;
`;
